import mitt from 'mitt'

const emitter = mitt()

export default {
  install: (app) => {
    app.provide("bus", {
      $on: emitter.on,
      $emit: emitter.emit,
      $off: emitter.off,
    });
  }
};
